import { h } from "preact";
import { useContext, useEffect, useState } from "preact/hooks";
import { ConfigContext } from "../AppContext";
import { GlobalsContext } from "../AppContext";
import style from "./main.css";
import SocialButton from "../components/SocialButton/SocialButton";
import HelpButton from "../components/HelpButton/HelpButton";
import TooltipComponent from "../components/TooltipComponent/TooltipComponent";
import clsx from "clsx";

const Main = () => {
    const config = useContext(ConfigContext);
    const { widgetOpen, setWidgetOpen } = useContext(GlobalsContext);
    const { widgetHidden, setWidgetHidden } = useContext(GlobalsContext);

    useEffect(() => {
        const isTooltipClosed = localStorage.getItem("tooltipClosed") === "true";

        setWidgetHidden(isTooltipClosed);
    }, []);

    if (widgetHidden) return;

    const initialBottomValue = window.innerWidth < 768
        ? config.positionBottomMobile
        : config.positionBottomDesktop || 40;

    const [bottomValue, setBottomValue] = useState(initialBottomValue);

    if (!config.socials) {
        return null;
    }

    useEffect(() => {
        const updateBottomValue = () => {
            if (window.innerWidth < 768 && config.positionBottomMobile !== undefined) {
                setBottomValue(config.positionBottomMobile);
            } else {
                setBottomValue(config.positionBottomDesktop || 40);
            }
        };

        updateBottomValue();

        window.addEventListener('resize', updateBottomValue);

        return () => window.removeEventListener('resize', updateBottomValue);
    }, [config.positionBottomDesktop, config.positionBottomMobile]);

    const inlineStyles = {
        bottom: `${bottomValue}px`,
    };

    const handleEmptyClick = (e) => {
        if (!e.target.closest('.widget-panel') && widgetOpen) {
            setWidgetOpen(false);
        }
    };

    const handleButtonClick = () => {
        setWidgetOpen(!widgetOpen);
    };

    useEffect(() => {
        document.addEventListener('click', handleEmptyClick);

        return () => {
            document.removeEventListener('click', handleEmptyClick);
        };
    }, [widgetOpen]);

    return (
        <div
            className={clsx(
                style.root,
                config.positionRight ? style.positionRight : style.positionLeft,
                widgetHidden && style.hidden,
                'widget-panel'
            )}
            style={inlineStyles}
        >
            <TooltipComponent tooltipTitle={config.tooltipTitle ? config.tooltipTitle : undefined} />
            <ul className={style.rootList}>
                {config.socials.map((social, index) => (
                    <li key={index} className={clsx(style.link, widgetOpen ? style.open : style.minimized)}>
                        <SocialButton title={social.title} url={social.url} onClick={handleButtonClick} />
                    </li>
                ))}
            </ul>
            <HelpButton />
        </div>
    );
};

export default Main;
